import React from 'react'
import PropTypes from 'prop-types'

import { useEventOnMount } from '../../ReactGAUtils/ReactGAUtils'
import Button from '../../Button/Button'
import PaperPlane from '../../../assets/paper-plane.svg'
import { PoweredByToastModal } from '../../PoweredByToastModal/PoweredByToastModal'

import './ForgotPasswordSuccessModal.css'

const ForgotPasswordSuccessModal = ({ onClose }) => {
  useEventOnMount({
    category: 'User Account',
    action: 'Forgot Password Success'
  })
  return (
    <PoweredByToastModal onClose={onClose}>
      <div styleName='centered'>
        <PaperPlane styleName='plane' />
        <h2>Email Sent</h2>
        <p styleName='body'>
          Check your email for instructions on resetting your password.
        </p>
        <i styleName='note'>
          *Note that you will only receive reset instructions if an account is
          associated with the email you entered.
        </i>
        <Button style='linkWide' type='button' onClick={onClose}>
          OK
        </Button>
      </div>
    </PoweredByToastModal>
  )
}

ForgotPasswordSuccessModal.propTypes = {
  onClose: PropTypes.func
}

export default ForgotPasswordSuccessModal
